// Function to fetch the token from the server
// Define a variable to store the token
import OpenAI from "openai";
import { Decoration, DecorationSet, EditorView, ViewPlugin,hoverTooltip } from "@codemirror/view";
import { RangeSetBuilder } from "@codemirror/state";
import '../index.css';
import { CONFIG_SCHEMA } from "../pages/configSchema.js";
import { useAuth } from '../pages/AuthContext';

let refreshing = null;
const refreshJwtToken = async () => {
    if (refreshing) return refreshing;
     //console.log("refreshJwtToken::1")

     //const token = localStorage.getItem("jwtToken");

     /*
     if (!token || token.trim() === "") {
        console.log("refreshJwtToken: no token, skipping refresh");
        return null;
      }
    */

      
    refreshing = (async () => {
      try {

        const data = await refreshAccessToken()
        console.log("refreshJwtToken::2",data)
        const newToken = data.token;
        const newExpiry = Date.now() + data.expiresIn * 1000;

        if (!newToken) {
            console.log("No token returned from refresh");
        }
        console.log("refreshJwtToken::3",newToken,newExpiry)

        //console.log("refreshJwtToken::3",newExpiry,newExpiry)
        localStorage.setItem("jwtToken", newToken);
        localStorage.setItem("jwtExpiry", newExpiry);
  
        refreshing = null;
        //return newToken;
      } catch (err) {
        refreshing = null;
        //logout(); // important
        const { logout} = useAuth();
        localStorage.clear();
        await logout();
        throw err;
      }
    })();
  
    return refreshing;
  };




/*
export const getAuthHeader = async (orgName) => {
  let token = localStorage.getItem("jwtToken");
  let expiry = localStorage.getItem("jwtExpiry");

  const now = Date.now();
  //console.log("toke::1",token)
  if (!token|| token==undefined) {
    console.log("refreshJwtToken::11")
    localStorage.clear();
    window.location.href = "/";
  }
  // 🔥 Token expired or missing
  if (!expiry || expiry <= now) {
    //if (expiry <= now) {
    console.log("refreshJwtToken::22")
    await refreshJwtToken();

    token = localStorage.getItem("jwtToken");
  }

  return {
    Authorization: token,
    "X-OrgName": orgName,
  };
};
*/



export const getAuthHeader = async (orgName) => {
    let token = localStorage.getItem("jwtToken");
    const expiry = Number(localStorage.getItem("jwtExpiry"));
  
    const now = Date.now();
  
    // Refresh if token is missing, expiry is missing,
    // or token expires within the next 5 minutes
    const REFRESH_BUFFER = 5 * 60 * 1000;
  
    if (
      !token ||
      !expiry ||
      expiry - now <= REFRESH_BUFFER
    ) {
      console.log("Refreshing JWT token...");
  
      try {
        await refreshJwtToken();
        token = localStorage.getItem("jwtToken");
  
        if (!token) {
          throw new Error("No token returned after refresh");
        }
  
      } catch (error) {
        console.error("Token refresh failed:", error);
  
        localStorage.clear();
        window.location.href = "/";
  
        throw error;
      }
    }
  
    return {
      Authorization: token,
      "X-OrgName": orgName,
    };
  };


/* Fetch New token (Refresh token) */
export const fetchNewToken = async (organisation,email,password) => {
    try {
        const requestBody = {
            organisation: organisation,
            email: email,
            password: password
        };
        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/token`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Error fetching token:', error);
        throw error; // Rethrow the error to handle it in the component
    }
};

const refreshAccessToken = async () => {
    try {

        // Send a refresh token request to your server
        const refreshTokenResponse = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/refreshToken`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
            },
        });

        if (!refreshTokenResponse.ok) {
            throw new Error('Token refresh failed');
        }

        const refreshedData = await refreshTokenResponse.json();
        return  refreshedData
    } catch (refreshError) {
        console.error('Error refreshing token:', refreshError);
        throw refreshError;
    }
};

/*
// Function to refresh the access token
const refreshAccessToken = async (refreshToken) => {
    try {

        const requestBody = {
            refreshToken:refreshToken
        };


        // Send a refresh token request to your server
        const refreshTokenResponse = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/refreshToken`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
            },
            body: JSON.stringify(requestBody)
            // Include the refresh token in the request body or headers
        });

        if (!refreshTokenResponse.ok) {
            throw new Error('Token refresh failed');
        }

        const refreshedData = await refreshTokenResponse.json();
        return  refreshedData
    } catch (refreshError) {
        console.error('Error refreshing token:', refreshError);
        throw refreshError;
    }
};

*/

/*  To show a list of connections */
export const fetchListConnections = async (file_type,level,org_name) => {
    try {
        //const token = await fetchToken();

        const requestBodyState = {
            org_name: org_name,
            architecture_name: "default",
            state_type: file_type,
            level : level

        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/listStateFiles`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        // Handle the response data from listStateFiles
        console.log("fetchListConnections::1",data); // You should see the list of connections in the console

        return data;
        // Do any additional processing or redirect as needed
    } catch (error) {
        console.error('Error fetching connections:', error);
    }
};

/*  Delete the connections */

export const handleDeleteConnection = async (connectionName,org_name,stateType) => {

    console.log(JSON.stringify(connectionName) + "connectionName");

    try {
        //const token = await fetchToken();

        const requestBodyState = {
            // org_name: 'testOrg',
            // architecture_name: 'testArch',
            // state_type: 'connections',
            org_name: org_name,
            architecture_name: "default",
            state_type: stateType,
            file_name: JSON.stringify(connectionName)
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/deleteStateFile`, {
            method: 'DELETE',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        })

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Error fetching connections:', error);
    }
};

export const addFile = async (formData,file_name, stateType,org_name) => {
    try {
        const requestBodyState = {
            org_name: org_name,
            architecture_name: "default",
            state_type: stateType,
            file_name: file_name,
            //file_content: JSON.stringify(formData)
            file_content: formData
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/createStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating new state file:', error);
        throw error;
    }
};

export const updateConnection = async (formData,file_name, org_name,arch_name,stateType = "config") => {
    try {
        const requestBodyState = {
            org_name: org_name,
            architecture_name: arch_name,
            state_type: stateType,
            file_name: file_name,
            file_content: formData
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/createStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating new state file:', error);
        throw error;
    }
};

export const testFile = async (formData,config_file_name,data_file_name,user, feature,org_name) => {
    try {
        console.log("inTestFile::1112", formData)
        const dir_path = "/home/stateFiles/" + org_name + "/" + "default"
        const dataFileName = data_file_name.split('/').pop();
        const requestBodyState = {
            file_path: `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org_name + "/" + formData.dir_path + "/" + user + "/" + dataFileName,
            config_file_path: dir_path + "/config/" + config_file_name,
            user:user,
            org_name: org_name,
        };
        let response;
        if (feature=="mqtt") {
        response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/process-mqtt`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });
    } else {
        response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/process-file`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });
    }
        const text = await response.text();

        // ❌ handle quota / backend string error
        if (text.toLowerCase().includes("quota")) {
            throw new Error(text);
        }

        if (!response.ok) {
            throw new Error(text || "Request failed");
        }


        return response
    } catch (error) {
        console.error('Error creating new state file:', error);
        throw error;
    }
};

export const loadFile = async (formData,config_file_name,data_file_name,user, feature,org_name,userName,header_org) => {
    try {
        console.log("inLoadFile::1112", formData)
        const dir_path = "/home/stateFiles/" + org_name + "/" + "default/reports"
        const dataFileName = data_file_name.split('/').pop();
        const requestBodyState = {
            //file_path: `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org_name + "/" + formData.dir_path + "/" + dataFileName,
            file_path: `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org_name + "/users/" + userName+ "/" + dataFileName + "/_invertible_data" + "/" + dataFileName,
            config_file_path: dir_path + "/" + config_file_name,
            user:user,
            org_name: org_name,
        };
        let response;
        if (feature=="mqtt") {
        response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/process-mqtt`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(header_org),
            },
            body: JSON.stringify(requestBodyState)
        });
    } else {
        response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/load-file`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(header_org),
            },
            body: JSON.stringify(requestBodyState)
        });
    }
        if (!response.ok) {
            const resp = await readTextFromStream(response.body)
            console.log("testFunc::1",resp)
            throw new Error(resp);
        }
        
        const data = await response;
        return data;
    } catch (error) {
        console.error('Error creating new state file:', error);
        throw error;
        }
    };


export const wrietSqlResultToFile = async (database,query,output_file_name,file_type,org_name) => {
    try {
        const requestBodyState = {
            database: database,
            query:query,
            file_name:output_file_name,
            file_type:file_type,
            org_name:org_name

        };
        //const response = await fetch("http://localhost:8000/file-write", {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/file-write`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        return response
    } catch (error) {
        console.error('Error creating new state file:', error);
        throw error;
    }
};

export const querySqlRustService = async (database,query,user,org) => {
    let query_str = "";
    if (query.toLowerCase().includes("select") && !query.toLowerCase().includes("group") && !query.toLowerCase().includes("distinct")) {
        if (query.toLowerCase().includes("limit")) {
            query_str=query
        } else if (query.toLowerCase().includes("update")) {
            query_str=query
        } else {
            query_str=`${query} LIMIT 500`
            //query_str = `${query.trim().replace(/;$/, "")} LIMIT 500`;
        }
    } else if (query.toLowerCase().includes("update")) {
        query_str=query
    } else {
        query_str=query
    } 
    console.log("responseRust::11",query_str,org)
    
    try {
        const requestBodyState = {
            //database:"." + database,
            database: database,
            query:query_str,
            user:user,
            org:org

        };
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/query`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org),
            },
            body: JSON.stringify(requestBodyState)
        });
        //console.log("responseRust::12",await response.text())
        
        const contentType = response.headers.get("content-type");
        console.log("responseRust::112",response)
        if (contentType && contentType=="application/json") {
            // Step 2: Parse as JSON
            //const data = await response.json();
            //console.log("✅ Query results:", response.json());
            return await response.json();
        } else {
            // Step 4: Fallback to text response
            //console.log("✅ Query text:", response.text());
            return response.text()
        }
    } catch (error) {
        console.error('Error in querySqlRustService:', error);
        throw error;
    }
};

export const fetchTableColumnsRust = async (database,query,user,org) => {
    let fetchedColumns;
    console.log("responseRust::11",query)
    
    try {
        const requestBodyState = {
            //database:"." + database,
            database: database,
            query:query,
            user:user,
            org:org

        };
        //const response = await fetch("http://localhost:8000/query", {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/query`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org),
            },
            body: JSON.stringify(requestBodyState)
        });
        const respObj = await response.text()
        console.log("responseRust::12",await respObj)
        try {
            // Attempt to parse the response text as JSON
            fetchedColumns = JSON.parse(respObj)["results"];
            console.log("fetchedColumns::1",fetchedColumns);

            // Filter out any commas (",") in the array
            //const filteredColumns = fetchedColumns.filter(column => column !== ",");

            // Parse the JSON strings and extract the "name" and "type" properties
            const columnData = fetchedColumns.map(column => {
                try {
                    //const parsedColumn = JSON.parse(column);
                    return {
                        name: column[1],
                        type: column[2]
                    };
                } catch (error) {
                    console.error(`Error parsing JSON for column: ${column}`);
                    return null; // Handle the error gracefully
                }
            });

            //console.log(JSON.stringify(columnData) + "columnData");

            // Use the map function to create sub-arrays
            const modifiedColumnNames = columnData.map(column => [column.name, column.type]);


            return modifiedColumnNames;
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return [];
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        throw error;
    }
};
/*
export const fetchTableRust = async (database,query,user,org) => {
    let fetchedTables;
    console.log("responseRust::11",query)
    
    try {
        const requestBodyState = {
            //database:"." + database,
            database: database,
            query:query,
            user:user,
            org:org

        };
        //const response = await fetch("http://localhost:8000/query", {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/query`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org),
            },
            body: JSON.stringify(requestBodyState)
        });

        const respObj = await response.text()
        console.log("responseRust::22",await respObj)

        if (respObj.toLowerCase().includes("quota")) {
            throw new Error(respObj|| "Monthly quota exceeded");
        }


        try {
            // Attempt to parse the response text as JSON
            fetchedTables = JSON.parse(respObj)["results"];
            const filterResult = fetchedTables.filter(item => item[0] !== "name");
            console.log("fetchedColumns::22",fetchedTables);

            // Filter out any commas (",") in the array
            //const filteredColumns = fetchedColumns.filter(column => column !== ",");

            // Parse the JSON strings and extract the "name" and "type" properties
            const columnData = filterResult.map(table => {
                try {
                    //const parsedColumn = JSON.parse(column);
                    return table[0]
                } catch (error) {
                    console.error(`Error parsing JSON for column: ${table}`);
                    return null; // Handle the error gracefully
                }
            });

            //console.log(JSON.stringify(columnData) + "columnData");

            // Use the map function to create sub-arrays


            return columnData;
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return [];
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        throw error;
    }
};
*/

export const fetchTableRust = async (database, query, user, org) => {
    try {
        const requestBodyState = {
            database,
            query,
            user,
            org,
        };

        const response = await fetch(
            `${process.env.REACT_APP_OMEGAPI_SERVICE}/query`,
            {
                method: "POST",
                headers: {
                    "Content-Type": process.env.REACT_APP_CONTENT_TYPE,
                    ...(await getAuthHeader(org)),
                },
                body: JSON.stringify(requestBodyState),
            }
        );

        const text = await response.text();

        // ❌ handle quota / backend string error
        if (text.toLowerCase().includes("quota")) {
            throw new Error(text);
        }

        if (!response.ok) {
            throw new Error(text || "Request failed");
        }

        const json = JSON.parse(text);
        const results = json.results || [];

        return results
            .filter(item => item[0] !== "name")
            .map(item => item[0]);

    } catch (error) {
        console.error("fetchTableRust error:", error);
        throw error;
    }
};

async function readTextFromStream(readableStream) {
    const reader = readableStream.getReader();
    const decoder = new TextDecoder();
    let result = '';
    
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      result += decoder.decode(value, { stream: true });
    }
    
    result += decoder.decode(); // flush
    return result;
  }
  

export const testFunc = async (funcName,funcCode,testData,org_name) => {
    try {
        const requestBodyState = {
                "function_name": funcName,
                "function_code": funcCode,
                "arguments":  testData.split(",").map(s => s.trim())
        };

        //const response = await fetch("http://localhost:8000/test-rhai", {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/test-rhai`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            const resp = await readTextFromStream(response.body)
            console.log("testFunc::1",resp)
            throw new Error(resp);
        }
        
        const data = await response;
        return data;
    } catch (error) {
        console.error('Error creating new state file:', error);
        throw error;
    }
};

export const getLog  = async (offset,database_path,org_name) => {
        try {
        // Existing test logic here...
    
        // Fetch logs after test
        const requestBodyState = {
            databsePath: database_path,
            sqlStatement: "SELECT * FROM invertible_logs ORDER BY log_time DESC LIMIT 50 OFFSET " + `${offset}`
        };

        //const token = await fetchToken();
        const logResponse = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/executeSql`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });
        //const logText = await logResponse.text();
        const data = await logResponse.text();
        return data;
        } catch (error) {
        console.error("Error during test:", error);
    }
  };

export const getStatus  = async (offset,database_path,file_path) => {
    try {
    // Existing test logic here...

    // Fetch logs after test
    const requestBodyState = {
        databsePath: database_path,
        sqlStatement: "SELECT * FROM invertible_metrics WHERE file_name='" + `${file_path}` +  "' ORDER BY log_time DESC LIMIT 50 OFFSET " + `${offset}`
    };

    //const token = await fetchToken();
    const logResponse = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/executeSql`, {
        method: 'POST',
        headers: {
            'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
            ...await getAuthHeader(""),
        },
        body: JSON.stringify(requestBodyState)
    });
    //const logText = await logResponse.text();
    const data = await logResponse.text();
    return data;
    } catch (error) {
    console.error("Error during test:", error);
}
};
  

export const copyFile = async (source_path, destination_path,org_name) => {
    try {
        const requestBodyState = {
            "source_path": source_path,
            "destination_path": destination_path
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/copyStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating new state file:', error);
        throw error;
    }
};

export const copyDir = async (source_path, destination_path,org_name) => {
    try {
        const requestBodyState = {
            "source_path": source_path,
            "destination_path": destination_path
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/copyDir`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating new state file:', error);
        throw error;
    }
};

/*  Read statefiles*/
export const readEachConnection = async (category,fileName, org_name) => {
    try {
        const requestBodyState = {
            org_name: org_name,
            architecture_name: "default",
            state_type: category,
            file_name: fileName
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/readStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        console.log("readEachConnection::1",JSON.stringify(response))
        //const text = await response.text();
        /*
        const data = await response.json();
        return data;
        */
       
        const text = await response.text();
        return text ? JSON.parse(text) :  {
        database: "",
        dir_path: "",
        file_type: "",
        staging_table: "",
        success_dir: "",
      };
      
    } catch (error) {
        console.error('Error reading state file:', error);
        throw error;
    }
};

export const readFiles= async (orgName,architectureName,stateType, fileName, home_dir) => {
    try {
        const requestBodyState = {
            org_name: orgName,
            architecture_name: architectureName,
            state_type: stateType,
            file_name: fileName,
            home_dir:home_dir
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/readStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(orgName),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            console.log('Request failed');
            throw new Error('Request failed');
        }
        console.log("readEachConnection::2",JSON.stringify(response))
        const data = await response.json();
        
        return data;
    } catch (error) {
        console.error('Error reading state file:', error);
        throw error;
    }
};

/* Delete reports */

export const deleteReports = async (connectionName, fileName, stateType,org_name) => {
    try {
        const requestBodyState = {
            state_type: stateType,
            org_name: org_name,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            connection_name: connectionName,
            file_name: JSON.stringify(fileName)
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/deleteStateFile`, {
            method: 'DELETE',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting state file:', error);
        throw error;
    }
};

/*  List of reports */

export const listOfReports = async (connectionName, org_name) => {
    try {
        const requestBodyState = {
            // org_name: 'testOrg',
            // architecture_name: 'testArch',
            // state_type: 'reports',
            org_name: org_name,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            state_type: `${process.env.REACT_APP_STATE_TYPE_REPORTS}`,

            connection_name: connectionName
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/listStateFiles`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        console.log(JSON.stringify(response) + "response");
        // const data = await response.json();
        // console.log(JSON.stringify(data)+"DATA");
        // Read the response text regardless of content type
        const responseText = await response.text();

        try {
            // Attempt to parse the response text as JSON
            const data = JSON.parse(responseText);
            //console.log(JSON.stringify(data) + "DATA");
            return data;
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return [];
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        throw error;
    }
};

/*  Read each report files in advance query builder */

export const readEachReportData = async (connectionName,reportName,org_name) => {
    try {
        const requestBodyState = {
            // org_name: 'testOrg',
            // architecture_name: 'testArch',
            // state_type: 'reports',
            org_name: org_name,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            state_type: `${process.env.REACT_APP_STATE_TYPE_REPORTS}`,
            connection_name: connectionName,
            file_name: reportName
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/readStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error reading report data:', error);
        return;
        throw error;
    }
};

/*   Generate sql */


export const generateSqlQuery = async (sqlArray) => {
    try {           

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/generateSql`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(sqlArray)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.text(); // Generating sql queries here
        console.log(data + "FETCH");
        return data;
    } catch (error) {
        console.error('Error generating SQL:', error);
        throw error;
    }
};

/*  Create new Report */

export const createNewReport = async (subDir, reportName, newReport,org_name) => {
    try {
        const requestBodyState = {
            // org_name: 'testOrg',
            // architecture_name: 'testArch',
            // state_type: 'reports',
            org_name: org_name,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            state_type: `${process.env.REACT_APP_STATE_TYPE_REPORTS}`,
            connection_name: subDir,
            file_name: reportName,
            file_content: JSON.stringify(newReport)
        };
        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/createStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating state file:', error);
        throw error;
    }
};


export const createNewChartReport = async (connectionName, reportName, newReport, sqlPayload,org_name) => {
    try {

        const requestBodyState = {
            // org_name: 'testOrg',
            // architecture_name: 'testArch',
            // state_type: 'charts',
            org_name: org_name,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            state_type: `${process.env.REACT_APP_STATE_TYPE_CHARTS}`,

            connection_name: `${connectionName}/${reportName}`,
            // connection_name: connectionName,
            file_name: reportName + `${sqlPayload}`,
            file_content: JSON.stringify(newReport)
        };


        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/createStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating state file:', error);
        throw error;
    }
};


/*  Generate SQL */


export const generateSql = async (sqlArray) => {
    try {


        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/generateSql`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(sqlArray)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error generating SQL:', error);
        throw error;
    }
};


/* create new connection */
export const showCatalog = async () => {
    try {
        const requestBody = `show catalogs`;
        console.log(JSON.stringify(requestBody) + "requestBody");

        const updatedNextUri = await fetchNextUri(requestBody);
        let currentNextUri = updatedNextUri; // Initialize the currentNextUri
        let dataArray = null;
        while (currentNextUri) {
            await wait(1000); // Wait for 3 seconds before each iteration

            const nextResponse = await fetch(currentNextUri, {
                method: 'GET',
                headers: {
                    'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                    ...await getAuthHeader(""),
                },
            });

            if (!nextResponse.ok) {
                throw new Error('Next request failed');
            }

            const nextData = await nextResponse.json();
            console.log("nextData : " + JSON.stringify(nextData));


            if (nextData.data && nextData.stats && nextData.stats.state === "FINISHED" || nextData.data && nextData.stats.state === "RUNNING") {
                // Data is available, retrieve and process the data array
                dataArray = nextData.data;
                console.log("Data Array:", dataArray);

            } else if (!nextData.nextUri && nextData.stats.state === "FINISHED") {
                // Data is available and there's no nextUri, indicating data retrieval is complete


                return dataArray;
            }


            const newNextURI = nextData.nextUri;
            console.log("Next URI:", newNextURI);
            const updatedNewNextUri = updateNextUri(newNextURI, 10000); // Replace port in nextUri
            console.log("updatedNewNextUri:", updatedNewNextUri);
            if (currentNextUri === updatedNewNextUri) {
                // No more nextUri, break the loop

                break;
            }
            currentNextUri = updatedNewNextUri; // Update the currentNextUri
        }

        return null;
    } catch (error) {
        console.error('Error in trino :', error);
        throw error; // Rethrow the error to handle it in the component
    }
};


/* showCatalogSchemas */
export const showCatalogSchemas = async (catalog) => {
    try {
        const requestBody = `show schemas from ${catalog}`;
        console.log(JSON.stringify(requestBody) + "requestBody");

        const updatedNextUri = await fetchNextUri(requestBody);
        let currentNextUri = updatedNextUri; // Initialize the currentNextUri
        let dataArray = null;
        while (currentNextUri) {
            await wait(1000); // Wait for 3 seconds before each iteration

            const nextResponse = await fetch(currentNextUri, {
                method: 'GET',
                headers: {
                    'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                    ...await getAuthHeader(""),
                },
            });

            if (!nextResponse.ok) {
                throw new Error('Next request failed');
            }

            const nextData = await nextResponse.json();
            console.log("nextData : " + JSON.stringify(nextData));


            if (nextData.data && nextData.stats && nextData.stats.state === "FINISHED" || nextData.data && nextData.stats.state === "RUNNING") {
                // Data is available, retrieve and process the data array
                dataArray = nextData.data;
                console.log("Data Array:", dataArray);

            } else if (!nextData.nextUri && nextData.stats.state === "FINISHED") {
                // Data is available and there's no nextUri, indicating data retrieval is complete


                return dataArray;
            }


            const newNextURI = nextData.nextUri;
            console.log("Next URI:", newNextURI);
            const updatedNewNextUri = updateNextUri(newNextURI, 10000); // Replace port in nextUri
            console.log("updatedNewNextUri:", updatedNewNextUri);
            if (currentNextUri === updatedNewNextUri) {
                // No more nextUri, break the loop

                break;
            }
            currentNextUri = updatedNewNextUri; // Update the currentNextUri
        }

        return null;
    } catch (error) {
        console.error('Error in trino :', error);
        throw error; // Rethrow the error to handle it in the component
    }
};



/* showCatalogSchemas */
export const showCatalogSchemasTables = async (schema) => {
    try {
        const requestBody = `SHOW TABLES FROM ${schema}`;
        console.log(JSON.stringify(requestBody) + "requestBody");

        const updatedNextUri = await fetchNextUri(requestBody);
        let currentNextUri = updatedNextUri; // Initialize the currentNextUri
        let dataArray = null;
        while (currentNextUri) {
            await wait(1000); // Wait for 3 seconds before each iteration

            const nextResponse = await fetch(currentNextUri, {
                method: 'GET',
                headers: {
                    'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                    ...await getAuthHeader(""),
                },
            });

            if (!nextResponse.ok) {
                throw new Error('Next request failed');
            }

            const nextData = await nextResponse.json();
            console.log("nextData : " + JSON.stringify(nextData));


            if (nextData.data && nextData.stats && nextData.stats.state === "FINISHED" || nextData.data && nextData.stats.state === "RUNNING") {
                // Data is available, retrieve and process the data array
                dataArray = nextData.data;
                console.log("Data Array:", dataArray);

            } else if (!nextData.nextUri && nextData.stats.state === "FINISHED") {
                // Data is available and there's no nextUri, indicating data retrieval is complete


                return dataArray;
            }


            const newNextURI = nextData.nextUri;
            console.log("Next URI:", newNextURI);
            const updatedNewNextUri = updateNextUri(newNextURI, 10000); // Replace port in nextUri
            console.log("updatedNewNextUri:", updatedNewNextUri);
            if (currentNextUri === updatedNewNextUri) {
                // No more nextUri, break the loop

                break;
            }
            currentNextUri = updatedNewNextUri; // Update the currentNextUri
        }

        return null;
    } catch (error) {
        console.error('Error in trino :', error);
        throw error; // Rethrow the error to handle it in the component
    }
};


/* showCatalogSchemas */
export const showCatalogSchemasTablesColumns = async (tablename) => {
    try {
        const requestBody = `
        SHOW COLUMNS FROM ${tablename}`;
        console.log(JSON.stringify(requestBody) + "requestBody");

        const updatedNextUri = await fetchNextUri(requestBody);
        let currentNextUri = updatedNextUri; // Initialize the currentNextUri
        let dataArray = null;
        while (currentNextUri) {
            await wait(1000); // Wait for 3 seconds before each iteration

            const nextResponse = await fetch(currentNextUri, {
                method: 'GET',
                headers: {
                    'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                    ...await getAuthHeader(""),
                },
            });

            if (!nextResponse.ok) {
                throw new Error('Next request failed');
            }

            const nextData = await nextResponse.json();
            console.log("nextData : " + JSON.stringify(nextData));


            if (nextData.data && nextData.stats && nextData.stats.state === "FINISHED" || nextData.data && nextData.stats.state === "RUNNING") {
                // Data is available, retrieve and process the data array
                dataArray = nextData.data;
                console.log("Data Array:", dataArray);

            } else if (!nextData.nextUri && nextData.stats.state === "FINISHED") {
                // Data is available and there's no nextUri, indicating data retrieval is complete

                console.log("no nexturi");
                return dataArray;
            }


            const newNextURI = nextData.nextUri;
            console.log("Next URI:", newNextURI);
            const updatedNewNextUri = updateNextUri(newNextURI, 10000); // Replace port in nextUri
            console.log("updatedNewNextUri:", updatedNewNextUri);
            if (currentNextUri === updatedNewNextUri) {
                // No more nextUri, break the loop
                console.log("break");
                break;
            }
            currentNextUri = updatedNewNextUri; // Update the currentNextUri
        }
        //generateSQLData
        return null;
    } catch (error) {
        console.error('Error in trino :', error);
        throw error; // Rethrow the error to handle it in the component
    }
};


export const deleteConnectionpg = async (connectionName) => {

    try {
        const requestBody = `
          drop catalog ${connectionName.name}
        `;
        console.log(JSON.stringify(requestBody) + "requestBody");
        const updatedNextUri = await fetchNextUri(requestBody);
        const fetchedDataArray = await fetchDataArray(updatedNextUri);
        console.log("Fetched Data Array:", fetchedDataArray);
        return fetchedDataArray;
    } catch (error) {
        console.error('Error in trino :', error);
        throw error; // Rethrow the error to handle it in the component
    }
};


// Function to replace port in a URI
function updateNextUri(uri, newPort) {
    const url = new URL(uri);
    url.port = newPort;
    url.host = "localhost";
    return url.toString().replace("v1/statement/", "v1/statement?uri=")
}

// Function to introduce a delay
function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Function to fetch data array from nextUri
async function fetchDataArray(nextUri) {
    let currentNextUri = nextUri;
    let dataArray = null;

    while (currentNextUri) {
        await wait(1000);

        const nextResponse = await fetch(currentNextUri, {
            method: 'GET',
        });

        if (!nextResponse.ok) {
            throw new Error('Next request failed');
        }

        const nextData = await nextResponse.json();
        console.log("nextData : " + JSON.stringify(nextData));

        if (nextData.stats && nextData.stats.state === "FINISHED") {
            dataArray = nextData.updateType;
            console.log("Data Array:", dataArray);
            break;
        } else if (nextData.stats && nextData.stats.state === "FAILED") {
            //  dataArray = nextData.error.message;
            dataArray = nextData.error;
            console.log("Data Array:", dataArray);
            break;
        }

        const newNextURI = nextData.nextUri;
        console.log("Next URI:", newNextURI);
        const updatedNewNextUri = updateNextUri(newNextURI, 10000);
        console.log("updatedNewNextUri:", updatedNewNextUri);

        if (currentNextUri === updatedNewNextUri) {
            break;
        }

        currentNextUri = updatedNewNextUri;
    }

    return dataArray;
}


const fetchNextUri = async (requestBody) => {
    try {
        //const response = await fetch("http://localhost:10000/v1/statement", {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/v1/statement`, {
            method: 'POST',
            headers: {
                'X-Trino-User': 'trino'
            },
            body: requestBody
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        const nextURI = data.nextUri;
        const updatedNextUri = updateNextUri(nextURI, 10000); // Replace port in nextUri
        return updatedNextUri;
    } catch (error) {
        console.error('Error in trino:', error);
        throw error; // Rethrow the error to handle it in the component
    }
};


/* create new connection */
export const generateSQLData = async (generateSqlQueryData) => {
    console.log(JSON.stringify(generateSqlQueryData) + "generateSqlQueryData::1");
    const limit = 5; // Define your limit value
    let requestBody = '';
    try {
        //    const generateSqlQueryData1 =  `SELECT  SUBSTRING(postcode,1,2) AS post1 , SUBSTRING(postcode,1,2) AS post2   FROM boolean.public.retail_sales  INNER JOIN boolean.public.retail_manager on SUBSTRING(postcode,1,2)=SUBSTRING(postcode,1,2)` 
        //  const requestBody =  `SELECT salesData.db.sales_table.Category  FROM salesData.db.sales_table LIMIT 500`;
        if (generateSqlQueryData.includes("Query:")){
            console.log("In execSqlStatement::1")
            requestBody = generateSqlQueryData.split("Query:")[1];
        } else if (generateSqlQueryData.includes("LIMIT")) {
            requestBody = `${generateSqlQueryData}`;
        } else {
            requestBody = `${generateSqlQueryData} LIMIT ${limit}`;
        }
        // const requestBody = `${generateSqlQueryData}`;
        console.log("In execSqlStatement::22", JSON.stringify(requestBody));

        const updatedNextUri = await fetchNextUri(requestBody);
        let currentNextUri = updatedNextUri; // Initialize the currentNextUri
        let dataArray = null;
        let columns = null; // Initialize columns
        while (currentNextUri) {
            await wait(1000); // Wait for 3 seconds before each iteration

            const nextResponse = await fetch(currentNextUri, {
                method: 'GET',
                headers: {
                    'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                    ...await getAuthHeader(""),
                },
            });

            if (!nextResponse.ok) {
                throw new Error('Next request failed');
            }


            const nextData = await nextResponse.json();
            console.log("nextData : " + JSON.stringify(nextData));
            if (nextData.error) {
                // Handle error in the response
                const errorMessage = nextData.error.message;
                console.error('Error message:', errorMessage);
                // You can set an error flag in your state or show an alert
                // this.setState({ error: true, errorMessage: errorMessage });
                // alert('Error message: ' + errorMessage);
                return { error: nextData.error.message };
            }

            if (nextData.data && nextData.stats && nextData.stats.state === "FINISHED" || nextData.data && nextData.stats.state === "RUNNING") {
                // Data is available, retrieve and process the data array
                dataArray = nextData.data;
                console.log("Data Array:", dataArray);

                if (columns === null) {
                    // Set columns only if not already set
                    columns = nextData.columns.map(column => column.name);
                }

            } else if (!nextData.nextUri && nextData.stats.state === "FINISHED") {
                // Data is available and there's no nextUri, indicating data retrieval is complete

                console.log("no nexturi");
                // return dataArray;
                return { data: dataArray, columns,requestBody };
            } else if (!nextData.nextUri && nextData.stats.state === "FAILED") {

                return { error: nextData.error.message }
            }


            const newNextURI = nextData.nextUri;
            console.log("Next URI:", newNextURI);
            const updatedNewNextUri = updateNextUri(newNextURI, 10000); // Replace port in nextUri
            console.log("updatedNewNextUri:", updatedNewNextUri);
            if (currentNextUri === updatedNewNextUri) {
                // No more nextUri, break the loop
                console.log("break");
                break;
            }
            currentNextUri = updatedNewNextUri; // Update the currentNextUri
        }

        return { data: null, columns: null };
    } catch (error) {
        console.error('Error in trino :', error);
        // Return an object with the error message
        return { error: error.message };
    }
};


// LIST OF REPORT PAGE

export const listOfFileNamesPage = async () => {
    try {
        const requestBodyState = {
            org_name: 'testOrg',
            architecture_name: 'testArch',
            state_type: 'charts',
            connection_name: 'boolean/grid'
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/listStateFiles`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        console.log(JSON.stringify(response) + "response");
        // const data = await response.json();
        // console.log(JSON.stringify(data)+"DATA");
        // Read the response text regardless of content type
        const responseText = await response.text();

        try {
            // Attempt to parse the response text as JSON
            const data = JSON.parse(responseText);
            console.log(JSON.stringify(data) + "DATA");
            return data;
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return [];
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        throw error;
    }
};

// LIST OF REPORT PAGE

export const listOfFileNamesPageDir = async (path) => {
    try {
        const requestBodyState = {
            "data_dir_path": path
        };

        //const response = await fetch(`http://localhost:9000/getDirTree`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/getDirTree`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        console.log(JSON.stringify(response) + "response");
        // const data = await response.json();
        // console.log(JSON.stringify(data)+"DATA");
        // Read the response text regardless of content type
        const responseText = await response.text();

        try {
            // Attempt to parse the response text as JSON
            const data = JSON.parse(responseText);
            //console.log("data:11",JSON.stringify(data));
            return data;
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return [];
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        throw error;
    }
};

export const uploadFilePath = async (fileName,org_name,user) => {
    try {
        console.log(JSON.stringify(fileName) + "---filename");

        const formData = new FormData();

        formData.append("file", fileName);
        
        let path = '/home/stateFiles/'+ org_name + "/" + "default" + "/uploads";
        if (org_name=="invertible_managed"){
            path = '/home/stateFiles/'+ org_name + "/" + "default" + "/uploads/" + user + "/uploads"

        }

        //const response = await fetch(`http://localhost:10000/uploadFile`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/uploadFile`, {
            method: 'POST',
            headers: {
                //Path: '/home/SqlBuilder/uploads'
                //Path: '/home/stateFiles/'+ org_name + "/" + "default" + "/uploads",
                Path: path,
                ...await getAuthHeader(org_name),
            },
            body: formData
        });

        if (response.ok) {

            console.log('File uploaded successfully:', response);
        } else {
            console.error('File upload failed:', response.status, response.statusText);
        }
        return response;
    } catch (error) {
        console.error('File upload failed:', error);
    }
};

/*
export const buildBinary = async (version,feature,enable_superset,license_start,license_end,org_name) => {
    try {
        const requestBodyState = {
            org_name: org_name,
            config_file_name:"",
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            "feature":feature,
            "version":version,
            enable_superset:enable_superset,
            license_start:license_start,
            license_end:license_end
        };

        //const response = await fetch(`http://localhost:8000/build`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/build`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            console.log("build response::1",response);
            if (typeof response === "string") {
                if (response.toLowerCase().includes("quota")) {
                throw new Error(response);
            } else{
            throw new Error('Request failed');
            }
            } 
        }
        const responseText = await response.json();
        console.log("build response::2",responseText);

        try {
            //const data = JSON.parse(responseText);
            //console.log("data:11",responseText["license_start"]);
            return responseText;
        } catch (error) {
            console.error('Error parsing JSON response:', error);
            return [];
        }
    } catch (error) {
        console.error('Error triggering build:', error);
        throw error;
    }
};
*/

export const buildBinary = async (
    version,
    feature,
    enable_superset,
    license_start,
    license_end,
    org_name
) => {
    try {
        const requestBodyState = {
            org_name,
            config_file_name: "",
            architecture_name: process.env.REACT_APP_ARCHITECTURE_NAME,
            feature,
            version,
            enable_superset,
            license_start,
            license_end,
        };

        const response = await fetch(
            `${process.env.REACT_APP_OMEGAPI_SERVICE}/build`,
            {
                method: "POST",
                headers: {
                    "Content-Type": process.env.REACT_APP_CONTENT_TYPE,
                    ...(await getAuthHeader(org_name)),
                },
                body: JSON.stringify(requestBodyState),
            }
        );

        // -----------------------------
        // HANDLE ERROR CASES FIRST
        // -----------------------------
        if (!response.ok) {
            const errorText = await response.text(); // <-- IMPORTANT

            if (errorText.toLowerCase().includes("quota")) {
                throw new Error(errorText || "Monthly quota exceeded");
            }

            throw new Error(errorText || "Request failed");
        }

        // -----------------------------
        // SUCCESS CASE
        // -----------------------------
        const contentType = response.headers.get("content-type");

        if (contentType?.includes("application/json")) {
            return await response.json();
        }

        return await response.text();

    } catch (error) {
        console.error("Error triggering build:", error);
        throw error;
    }
};

export const prepareBuild = async (fileName,version,feature,org_name,enable_superset,license_start,license_end) => {
    try {
        const requestBodyState = {
            org_name: org_name,
            config_file_name: fileName,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            "feature":feature,
            "version":version,
            enable_superset:false,
            license_start:"",
            license_end:""
            
        };
    
    console.log("requestBodyState::1",JSON.stringify(requestBodyState))

    const response = await fetch(`${process.env.REACT_APP_OMEGAPI_SERVICE}/prepareBuild`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        const text = await response.text();

        // ❌ handle quota / backend string error
        if (text.toLowerCase().includes("quota")) {
            throw new Error(text);
        }

        if (!response.ok) {
            throw new Error(text || "Request failed");
        }


        try {
            return response;
        } catch (error) {
            console.error('Error parsing JSON response:', error);
            return [];
        }
    } catch (error) {
        console.error('Error triggering build:', error);
        throw error;
    }
};


export const downloadFilePath = async (path) => {
    try {
        const requestBodyState = {
            "filePath": path
        };
        //const response = await fetch(`http://localhost:3000/downloadFile`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/downloadFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (response.ok) {
            //  const content = await response.text();
            const content = await response.arrayBuffer();

            console.log('File downloaded successfully:', content);
            return content;

            // Future use : 
            // if (fileType === 'pdf') {
            //     // Handle PDF file
            //     const content = await response.blob();
            //     return content;
            // } else if (fileType === 'csv' || fileType === 'txt' || fileType === 'excel') {
            //     // Handle text-based or Excel files
            //     const content = await response.text();
            //     return content;
            // } else if (fileType === 'json') {
            //     // Handle JSON files
            //     const content = await response.json();
            //     return content;
            // } else {
            //     // Handle other or unknown file types as binary data
            //     const content = await response.arrayBuffer();
            //     return content;
            // }


        } else {
            console.error('File downloaded failed:', response.status, response.statusText);
        }
        // return response;
    } catch (error) {
        console.error('File download failed:', error);
    }
};

function parseKeyValue(text) {
    const result = {};
    for (const line of text.split("\n")) {
      const [key, value] = line.split("=");
      if (key && value) result[key.trim()] = value.trim();
    }
    return result;
  }
  
export const readTextFile= async (orgName,architectureName,stateType, fileName, home_dir) => {
    try {
        const requestBodyState = {
            org_name: orgName,
            architecture_name: architectureName,
            state_type: stateType,
            file_name: fileName,
            home_dir:home_dir
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/readStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(orgName),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            console.log('Request failed');
            throw new Error('Request failed');
        }
        const data = await response.text()
        //console.log("readEachConnection::2",data)
        return parseKeyValue(data);
    } catch (error) {
        console.error('Error reading state file:', error);
        throw error;
    }
};



/*  Read each connection */
export const readEachFileConnection = async (filepath, nodename, org_name) => {
    try {
        const requestBodyState = {
            org_name: org_name,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            state_type: filepath,
            // connection_name: nodename,
            file_name: nodename
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/readStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        console.log("json::1123",JSON.stringify(response))

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error reading state file:', error);
        throw error;
    }
};


/*  Read each connection */
export const loadFilesActions = async (fileName, schema, table, fileFormatTypeValue,
    chunkSize, ifTableExists) => {
    try {
        const requestBodyState = {
            file_path: `/home/bookworm/files/${fileName}`,
            database_path: `/home/bookworm/databases/${schema}`,
            table_name: table,
            if_table_exists: ifTableExists,
            file_format: fileFormatTypeValue,
            chunk_size: parseInt(chunkSize, 10)
        };

        //const response = await fetch(`http://localhost:4000/loadFile`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/loadFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error reading state file:', error);
        throw error;
    }
};

//load all the files 


/*  Read each connection */
export const loadAllFilesActions = async (fileName, schema, table, fileFormatTypeValue,
    chunkSize, ifTableExists) => {
    try {
        const requestBodyState = {
            file_path: `/home/bookworm/files/${fileName}`,
            // file_path: `/home/bookworm/files`,
            database_path: `/home/bookworm/databases/${schema}`,
            table_name: table,
            if_table_exists: ifTableExists,
            file_format: fileFormatTypeValue,
            chunk_size: parseInt(chunkSize, 10)
        };

        //const response = await fetch(`http://localhost:4000/loadFile`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/loadFile`, { 
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error reading state file:', error);
        throw error;
    }
};

// SQLite API call for list of datatabases


/*  To show a list of connections */
export const fetchSqliteListDatabases = async () => {
    try {
        const requestBodyState = {
            
            "data_dir_path": "/home/stateFiles/Databases"
        };

        //const response = await fetch(`http://localhost:9000/getDirTree`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/getDirTree`, { 
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        console.log(JSON.stringify(response) + "response");
        // const data = await response.json();
        // console.log(JSON.stringify(data)+"DATA");
        // Read the response text regardless of content type
        const responseText = await response.text();

        try {
            // Attempt to parse the response text as JSON
            const data = JSON.parse(responseText);
            console.log(JSON.stringify(data) + "DATA");
            return data;
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return [];
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        throw error;
    }
};


/*  To show a list of connections */
export const fetchSqliteListTables = async (databaseInitalValue) => {
    let tableNames = [];
    try {
        const requestBodyState = {

            //"databsePath": `/home/databases/${databaseInitalValue}`, "sqlStatement": "SELECT name FROM sqlite_schema WHERE type='table' ORDER BY name"
            "databsePath": databaseInitalValue, "sqlStatement": "SELECT name FROM sqlite_schema WHERE type='table' ORDER BY name"
        };

        //const response = await fetch(`http://localhost:10001/executeSql`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/executeSql`, { 
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        console.log(JSON.stringify(response) + "response");
        // const data = await response.json();
        // console.log(JSON.stringify(data)+"DATA");
        // Read the response text regardless of content type
        const responseText = await response.text();

        try {
            // Attempt to parse the response text as JSON
            const fetchedTables = JSON.parse(responseText);
            console.log(JSON.stringify(fetchedTables) + "fetchedTables");

            if (fetchedTables && fetchedTables.length > 0) {
                // Filter out any commas (",") in the array
                const filteredTables = fetchedTables.filter(table => table !== ",");

                // Parse the JSON strings and extract the "name" property
                tableNames = filteredTables.map(table => {
                    try {
                        const parsedTable = JSON.parse(table);
                        return parsedTable.name;
                    } catch (error) {
                        console.error(`Error parsing JSON for table: ${table}`);
                        return null; // Handle the error gracefully
                    }
                });

                console.log(JSON.stringify(tableNames) + "tableNames");
            }

            return tableNames;
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return [];
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        throw error;
    }
};



/*  To show a list of connections */
export const fetchSqliteListColumns = async (databaseInitialValue, tableInitialValue) => {
    let fetchedColumns = [];
    try {
        const requestBodyState = {

            //"databsePath": `/home/databases/${databaseInitialValue}`, "sqlStatement": `pragma table_info(${tableInitialValue})`
            "databsePath": databaseInitialValue, "sqlStatement": `pragma table_info(${tableInitialValue})`
        };

        //const response = await fetch(`http://localhost:10001/executeSql`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/executeSql`, { 
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        console.log(JSON.stringify(response) + "response");
        // const data = await response.json();
        // console.log(JSON.stringify(data)+"DATA");
        // Read the response text regardless of content type
        const responseText = await response.text();

        try {
            // Attempt to parse the response text as JSON
            fetchedColumns = JSON.parse(responseText);
            //console.log(JSON.stringify(fetchedColumns) + "fetchedColumns");

            // Filter out any commas (",") in the array
            const filteredColumns = fetchedColumns.filter(column => column !== ",");

            // Parse the JSON strings and extract the "name" and "type" properties
            const columnData = filteredColumns.map(column => {
                try {
                    const parsedColumn = JSON.parse(column);
                    return {
                        name: parsedColumn.name,
                        type: parsedColumn.type
                    };
                } catch (error) {
                    console.error(`Error parsing JSON for column: ${column}`);
                    return null; // Handle the error gracefully
                }
            });

            //console.log(JSON.stringify(columnData) + "columnData");

            // Use the map function to create sub-arrays
            const modifiedColumnNames = columnData.map(column => [column.name, column.type]);


            return modifiedColumnNames;
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return [];
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        throw error;
    }
};

export const fetchSqliteQueryResponse = async (databaseInitialValue, query) => {
    console.log("fetchSqliteQueryResponse ::1")
    let query_str = "";
    if (query.toLowerCase().includes("limit")) {
        query_str=query
    } else {
        query_str=`${query} LIMIT 500`
    }
    try {
        const requestBodyState = {

            "databsePath": databaseInitialValue, "sqlStatement": query_str
        };

        //const response = await fetch(`http://localhost:10001/executeSql`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/executeSql`, { 
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        const data = await response.json();
        console.log("sqlResponse::1", data);
        // console.log(JSON.stringify(data)+"DATA");
        // Read the response text regardless of content type
        //const responseText = await response.Array();
        return data

       
        // return data;
    } catch (error) {
        console.error('Error executing sql:', error);
        throw error;
    }
};

export const fetchSqliteQueryResponseNoLimit = async (databaseInitialValue, query) => {
    console.log("fetchSqliteQueryResponse ::1")
    try {
        const requestBodyState = {

            "databsePath": databaseInitialValue, "sqlStatement": `${query}`
        };

        //const response = await fetch(`http://localhost:10001/executeSql`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/executeSql`, { 
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        const data = await response.json();
        console.log("sqlResponse::1", data);
        // console.log(JSON.stringify(data)+"DATA");
        // Read the response text regardless of content type
        //const responseText = await response.Array();
        return data

       
        // return data;
    } catch (error) {
        console.error('Error executing sql:', error);
        throw error;
    }
};


/*  To show a list of connections */
export const generateSqliteQueryResponse = async (databaseInitialValue, generateSqlQueryData) => {
    let fetchedgridResponse = [];
    try {
        const requestBodyState = {

            "databsePath": databaseInitialValue, "sqlStatement": `${generateSqlQueryData} LIMIT 500`
        };

        //const response = await fetch(`http://localhost:10001/executeSql`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/executeSql`, { 
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            const errorMessage = `HTTP Error ${response.status}: ${response.statusText}`;
            console.error(errorMessage);

            // Throw an error to capture the error and display it as needed
            return { error: errorMessage };
        }
        console.log(response + "response");

        // Read the response text regardless of content type
        const responseText = await response.text();
        try {
            // Attempt to parse the response text as JSON
            fetchedgridResponse = JSON.parse(responseText);
            console.log(JSON.stringify(fetchedgridResponse.Error) + "pafetchedgridResponsersedata");
            // Replace the incorrect escaped double quotes within the "Error" field
            if (fetchedgridResponse.Error && fetchedgridResponse.Code) {
                const errorMessage = fetchedgridResponse.Error;
                const errorCode = fetchedgridResponse.Code;
                return { error: `HTTP Error ${errorCode}: ${errorMessage}` };
            } else {
                console.log(fetchedgridResponse + "fetchedgridResponse");
                return fetchedgridResponse;
            }
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return { error: error.message };
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        return { error: error.message };
    }
};

//to delete the filecontent 



/*  To show a list of connections */
export const deleteSqliteFileTableContent = async (schema, tableName, filePath, fileOrFolder) => {
    let fetchedColumns = [];
    let requestBodyState = '';

    try {

        if (fileOrFolder == 'file') {
            requestBodyState = {

                "databsePath": `/home/databases/${schema}`, "sqlStatement": `delete from ${tableName} where _fileName='${filePath}'`
            };
        } else {
            requestBodyState = {

                "databsePath": `/home/databases/${schema}`, "sqlStatement": `delete from ${tableName} where _fileName LIKE '%${filePath}%'`
            };
        }


        //const response = await fetch(`http://localhost:10001/executeSql`, {
        const response = await fetch(`${process.env.REACT_APP_OMEGAPI_FILE_SERVICE}/executeSql`, { 
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        console.log(JSON.stringify(response) + "response");
        // const data = await response.json();
        // console.log(JSON.stringify(data)+"DATA");
        // Read the response text regardless of content type
        const responseText = await response.text();

        try {
            // Attempt to parse the response text as JSON
            fetchedColumns = JSON.parse(responseText);
            console.log(JSON.stringify(fetchedColumns) + "fetchedColumns");


            return fetchedColumns;
        } catch (error) {
            // Handle non-JSON responses gracefully
            console.error('Error parsing JSON response:', error);

            // Return an empty array if the response is not valid JSON
            return [];
        }
        // return data;
    } catch (error) {
        console.error('Error fetching list of reports:', error);
        throw error;
    }
};


// createnewconnection kafka save json file

/* Create new connection */
export const createNewJSONContent = async (category,editFileName, contentData,org_name) => {
    try {
        const requestBodyState = {
            org_name: org_name,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            state_type: category,
            file_name: editFileName,
            file_content: JSON.stringify(contentData)
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/createStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating new connection:', error);
        throw error;
    }
};

export const updateFile = async (category,editFileName, contentData,action,org_name) => {
    try {
        const requestBodyState = {
            org_name: org_name,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            // directory_name: 'kafkaJsonFiles/' + editFileName,
            state_type: category,
            file_name: editFileName,
            file_content: JSON.stringify(contentData),
            action:action
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/updateStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating new connection:', error);
        throw error;
    }
};


/*  To show a list of connections */
export const fetchListJsonFiles = async (org_name) => {
    try {
        const requestBodyState = {
            org_name: org_name,
            architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
            state_type: 'kafkaJsonFiles'

        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/listStateFiles`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }
        //const data = await response.text();

        const data = await response.json();
        // Handle the response data from listStateFiles
        console.log(data); // You should see the list of connections in the console

        return data;
        // Do any additional processing or redirect as needed
    } catch (error) {
        console.error('Error fetching connections:', error);
    }
};



/*  Read each connection */
export const readEachJsonFileContent = async (nodename) => {
    try {
        const requestBodyState = {
            org_name: 'testOrg',
            architecture_name: 'testArch',
            state_type: 'kafkaJsonFiles',
            // connection_name: nodename,
            file_name: nodename
        };

        const response = await fetch(`${process.env.REACT_APP_SQL_GENERATOR}/readStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(""),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error reading state file:', error);
        throw error;
    }
};

const callChatGpt = async (modelName, apiKey,messages = [],advancedParams) => {
    //const apiKey = process.env.REACT_APP_OPENAI_API_KEY;
    
    const cleanedParams = {};
    for (const [key, value] of Object.entries(JSON.parse(advancedParams))) {
        if (
            value !== null &&
            value !== '' &&
            !(Array.isArray(value) && value.length === 1 && value[0] === '') &&
            value !== undefined
        ) {
            cleanedParams[key] = value;
        }
    }
    console.log("cleanedParams::1",cleanedParams)
    const client = new OpenAI({
        apiKey: process.env.REACT_APP_OPENAI_API_KEY,
        dangerouslyAllowBrowser: true // Only use in trusted environments (e.g., development)
    });

    const response = await client.chat.completions.create({
        model: modelName,
        messages: messages,
        ...cleanedParams
    });

    const reply = response?.choices?.[0]?.message?.content;
    console.log("openapi_response::", reply);
    return reply;
};


const callSqlcoder7b = async (message,tableSchemas) => {
    //SELECT sql FROM sqlite_master WHERE type = 'table' AND name NOT LIKE 'sqlite_%';
    console.log("sqlcoder-7b::12",tableSchemas)
    const requestBodyState = {
            "question": message,
            //"schema": "CREATE TABLE Products (   product_id number,   parent_product_id number,   product_name text,   product_price number,   product_color text,   product_size text,   product_description text );  CREATE TABLE Customers (   customer_id number,   gender_code text,   customer_first_name text,   customer_middle_initial text,   customer_last_name text,   email_address text,   login_name text,   login_password text,   phone_number text,   address_line_1 text,   town_city text,   county text,   country text );  CREATE TABLE Customer_Payment_Methods (   customer_id number,   payment_method_code text );  CREATE TABLE Invoices (   invoice_number number,   invoice_status_code text,   invoice_date time );  CREATE TABLE Orders (   order_id number,   customer_id number,   order_status_code text,   date_order_placed time );  CREATE TABLE Order_Items (   order_item_id number,   product_id number,   order_id number,   order_item_status_code text );  CREATE TABLE Shipments (   shipment_id number,   order_id number,   invoice_number number,   shipment_tracking_number text,   shipment_date time );  CREATE TABLE Shipment_Items (   shipment_id number,   order_item_id number );"
            "schema":tableSchemas
    };

     //const response = await fetch("http://localhost:8001/generate", {
    const response = await fetch(`${process.env.REACT_APP_AGENT_AI_SERVICE}/generate`, { 
        method: 'POST',
        headers: {
            'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
        },
        body: JSON.stringify(requestBodyState)
    });

    if (!response.ok) {
        throw new Error('Request failed');
    }

    const data = await response.text();
    // Handle the response data from listStateFiles
    console.log("Sqlcoder7b:22",data)

    return data
};


export const fetchLlmResp = async (prompt,vendor, url, key,modelName,advancedParams,tableSchemas) => {
    try {
        if (vendor=="openapi"){
            console.log("in_openapi::1",prompt);
            const data = await callChatGpt(modelName,key,prompt,advancedParams)
            return data

        } else if (vendor=="sqlcoder-7b"){
            console.log("sqlcoder-7b::123",prompt,tableSchemas);
            const data = await callSqlcoder7b(prompt[prompt.length -1],tableSchemas)
            const cleaned = data.trim().replace(/^["']|["']$/g, '');
            return cleaned

        } else if (vendor=="aws") {
            const requestBodyState = {
                model: modelName,
                messages: [{content : prompt}],
            };
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                    ...await getAuthHeader(""),
                },
                body: JSON.stringify(requestBodyState)
            });

            if (!response.ok) {
                throw new Error('Request failed');
            }

            const data = await response.json();
            // Handle the response data from listStateFiles
            console.log("llmrep::22", data["choices"][0]["message"]["content"]); // You should see the list of connections in the console

            return data["choices"][0]["message"]["content"];
        }
        // Do any additional processing or redirect as needed
    } catch (error) {
        console.error('Error fetching connections:', error);
    }
};

export const authenticateUser = async (url, orgName, userName, pass) => {
    try {

        const requestBodyState = {
            // org_name: 'testOrg',
            // architecture_name: 'testArch',
            // state_type: 'connections',
            org_name: orgName,
            email: userName,
            password: pass
        };
        console.log("authuser::11", orgName, userName, pass, JSON.stringify(requestBodyState));
        //http://localhost:4000/getOmegapi
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(orgName),
            },
            body: JSON.stringify(requestBodyState)
        });

        if (!response.ok) {
            throw new Error('Request failed');
        }

        const data = await response.json();
        // Handle the response data from listStateFiles
        console.log("authuser::22", data["status"]); // You should see the list of connections in the console

        return data["status"];
        // Do any additional processing or redirect as needed
    } catch (error) {
        console.error('Error fetching connections:', error);
    }
};


export const extractFuncDescription = async (sourceCode, functionName) => {
  const regex = new RegExp(
    `/\\*\\s*([\\s\\S]*?)\\s*\\*/\\s*(fn\\s+${functionName}\\s*\\([^)]*\\))`
  );
  const match = sourceCode.match(regex);

  if (!match) return null;

  // Extract and clean docstring
  const docLines = match[1]
    .trim()
    .split('\n')
    .map(line => line.trim())
    .filter(line => line.length > 0);

  const description = docLines.join('. ') + (docLines.length > 0 ? '.' : '');

  // Extract function signature
  const signature = match[2].trim();

  return {
    signature: signature,
    description: description,
  };
}

// Define tooltip text per key
const tooltipsByKey = {
    database: "Database name to create tables",
    dir_path: "The directory to watch for files",
    staging_table:"Table to load file data. First step in the ETL process",
    trim_suffix:"Any Extra character to trim at the end of the row",
    header_identifier:"For files with header not on first line.Options:columns:Use this to set keyword to identify the header row, line:Use this to set line number to identify the header row",
    header_row_identifier: "Keyword+(the number of lines after) for files with multiple headers e.g.Create date+1",
    header_selection: "Value:lifo.For files with headers distributed in multiple headers,choose the value from the second row as column value",
    success_dir: "The directory to move the file after successful processing",
    failure_dir: "The directory to move the file after failed processing",
    file_type: "File type to process. Options: [csv,json,excel,xml]",
    host: "Mqtt host address e.g. test.mosquitto.org",
    "schedule": "Schedule to run the query on the raw mqtt data:Type: Integer e.g.30",
    "port": "Mqtt port Type Integer e.g.1883",
    "topic": "Mqtt Topic name e.g. sensors/temperature",
    "batch_mode": "collect messages in a batch before further prcessing:Type boolean e.g. true",
    "batch_size": "Batch size if batch_mode is true: Type Integer  e.g. 5",
    "wait_time": "Wait before next polling:Type Integer  e.g. 5",
    "depth": "In case of nested messages how many levels deep should be flatened:Type Integer  e.g. 1",
    "qos_level": "Mqtt Quality of service for message delivery.Type::Integer. Options[0::AtMostOnce,1 ::AtLeastOnce,2 ::ExactlyOnce]. Default is 1",
    "clean_session": false,
    staging_validations:`An arry of validation conditions to validate data in staging table before loading.Options:
    [ {
      "type": Option:"row_count" data validation check based on row count
      "name": "row_count >= 2000", name of the check for logging
      "query": "SELECT count(*) FROM csv_accomodation_staging_data WHERE _invertible_ingestion_time >= ?",In the query optionally providing "?" will be substiuted by the latest timestamp
      "threshold": 2000. The threshold less than which will stop processing
      },
      
      AND/OR

      {
      "type": Option:"condition_check" Custom condition for data validation,
      "name": "revenue_total is not NULL", name of the check for logging
      "query": "SELECT count(*) as cnt FROM csv_accomodation_staging_data WHERE _invertible_ingestion_time >= ? and revenue_total is NULL",
      "condition": "cnt = 0". The column and value making the condition continue processing
    },
    ]`,

    queries:`Each query sets the next stage for ETL on the data.Options:
    [ {
      "query": "UPDATE csv_accomodation_staging_data SET create_date = parse_custom_date(create_date),status_date = parse_custom_date(status_date) WHERE _invertible_ingestion_time >= ?;",In the query optionally providing "?" will be substiuted by the latest timestamp
      "validations": [
        {
          "type": ,Option:"query_condition_check" Custom condition for data validation,
          "name": "revenue_total is not NULL":Name of the check for logging
          "query": "SELECT count(*) as cnt FROM {table} WHERE _invertible_ingestion_time >= ? and create_date LIKE '____-__-__'", Query to run the check
          "condition": "cnt = 0" The column and value making the condition continue processing
        },
        {
      "query": "SELECT  * from csv_accomodation_staging_data  WHERE datetime(_invertible_ingestion_time) >= datetime('now', '-2 minutes')",Query 
      "destination": Decides where to write the query result to
      {
        "type": "csv" Type of destination Options:Files:["csv","parquet,table]
        "location": "csv_accomdation/accomodation.csv_?.csv" : Options: For csv and parquet name and location to write the result to or tbale name for type: Table
      }
    }
    ]`,
    query:`Query to run on the data.If used "?" will be substiuted by the latest timestamp`,
    type:`Options:["row_count" data validation check based on row count,"condition_check" Custom condition for data validation used in staging_validations,query_condition_check" Custom condition used in queries block,]`,
    name:`Name of the check for logging`,
    threshold: `For row_count validation.The threshold less than which will stop processing`,
    condition: `The column and value making the condition continue processing`,
    validations:`An arry of validation conditions to validate data after runnning queries`,
    location: "Options: For csv and parquet name and location to write the result to or table name for type: table e.g. csv_accomdation",
    destination:"Block to define the query result write location",
    _invertible_version:`Omegapi specific metadata.Do not Edit/Delete`,
    _invertible_feature:`Omegapi specific metadata.Do not Edit/Delete`,

  };

  const mqttTooltipsByKey = {
        host: "Mqtt host address e.g. test.mosquitto.org",
        "port": "Mqtt host address Type Integer e.g.1883",
        "topic": "Mqtt Topic name e.g. sensors/temperature",
        "batch_mode": "collect messages in a batch before further prcessing:Type boolean e.g. true",
        "batch_size": "Batch size if batch_mode is true: Type Integer  e.g. 5",
        "wait_time": "Wait before next polling:Type Integer  e.g. 5",
        "depth": "In case of nested messages how many levels deep should be flatened:Type Integer  e.g. 1",
        "database": "Database name to create tables e.g. tes.db",
        "staging_table": "Table to load file data. This is the first step in the ETL process e.g.mqtt_temperature_staging_data",
        "qos_level": "Mqtt Quality of service for message delivery.Type::Integer. Options[0::AtMostOnce,1 ::AtLeastOnce,2 ::ExactlyOnce]. Default is 1",
        "clean_session": false,
        "queries": [
          {
            "schedule": "Schedule to run the query on the raw mqtt data:Type: Integer e.g.30",
            "validations": [
              {
                "type": "Option:`condition_check` Custom condition for data validation",
                "name": "Name of the check for logging e.g revenue_total is not NULL",
                "query": "The SQL query to run the validation. Uisng `?` will be substiuted by the latest timestamp e.g. SELECT count(*) as cnt FROM mqtt_temperature_staging_data WHERE _invertible_ingestion_time >= ? and temp = 0",
                "condition": "The column and value making the condition to pass validation e.g. cnt = 0"
              }
            ]
          },
          {
            "query": "Query to genrate the final result set e.g. SELECT  * from mqtt_temperature_staging_data  WHERE datetime(_invertible_ingestion_time) >= datetime('now', '-2 minutes')",
            "schedule": "Schedule to run the query on the raw mqtt data:Type: Integer e.g.30",
            "destination": {
              "type": "Type of destination to write the final result set data to.Options For files:['csv','parquet'] or Option'table'] e.g. csv",
              "location": "Options: For csv and parquet name and location to write the result to or table name for type: table e.g. csv_accomdation/accomodation.csv_?.csv or test_table"
            }
          }
        ],
    _invertible_version:`Omegapi specific metadata.Do not Edit/Delete`,
    _invertible_feature:`Omegapi specific metadata.Do not Edit/Delete`,

  };

export const jsonTooltipExtension = hoverTooltip((view, pos) => {
    const word = view.state.wordAt(pos);
    if (!word) return null;
  
    const text = view.state.doc.sliceString(word.from, word.to);
    const cleanKey = text.replace(/"/g, "").replace(/:$/, "");
    
    const tooltipText = tooltipsByKey[cleanKey];
    if (!tooltipText) return null;
  
    return {
      pos: word.from,
      end: word.to,
      above: true,
      create() {
        const dom = document.createElement("div");
        dom.textContent = tooltipText;
        dom.className = "json-tooltip";
        return { dom };
      }
    };
  });

export const mqttJsonTooltipExtension = hoverTooltip((view, pos) => {
    const word = view.state.wordAt(pos);
    if (!word) return null;

    const text = view.state.doc.sliceString(word.from, word.to);
    const cleanKey = text.replace(/"/g, "").replace(/:$/, "");

    const tooltipText = mqttTooltipsByKey[cleanKey];
    if (!tooltipText) return null;

    return {
        pos: word.from,
        end: word.to,
        above: true,
        create() {
        const dom = document.createElement("div");
        dom.textContent = tooltipText;
        dom.className = "json-tooltip";
        return { dom };
        }
    };
});


 export const buildConfigWithSchema = async (requirements) => {
    const databaseSchema=""

    const systemMessage = {
      role: "system",
      content: "You are an ETL config generator. \
        Always return valid JSON with SQL queries that work in SQLite. \
        Queries must use '?' for dynamic parameters. \
        If given error feedback, revise the JSON and fix queries."
    };
  
    const userMessage = {
      role: "user",
      content: `Database schema:\n${databaseSchema}\n\n \
        Requirements:\n${requirements}\n\n \
        Generate ETL config JSON using template ${CONFIG_SCHEMA}.
        Use placeholders if you cananot determine values \
        Prioritize database and table names from Requirements \
        Genrate own queries for validations \
        Do not include 'type', 'object', 'properties', or 'required' in the final output.\
        Respond with JSON only. Do not include explanations, markdown fences, or text outside the JSON object.`
    };
  
    const response = await callChatGpt(
      "gpt-4o-mini",   // or whichever model you prefer
      process.env.REACT_APP_OPENAI_API_KEY,
      [systemMessage, userMessage],
      JSON.stringify({
        temperature: 0,
        response_format: { type: "json_object" } // force JSON output
      })
    );
  
    try {
      return JSON.parse(response);
    } catch (err) {
      console.error("❌ Failed to parse response:", response, err);
      throw err;
    }
  };

export const getAgentAiConfig = async (sourceType,source,host,database,stagingTable,queries,description,exportFormat,exportDest,headerIdentifier,headerRowIdentifier,headerRowNumber,headerSelection,trimSuffix,manualSchema,successPath,failurePath,model,apiKey,depth,contentTag,fileType,existingConfig,org_name,port) => {
        try {
        let requestBodyState = {};
        if (fileType=="json") {
         requestBodyState = {
            source:source,
            successPath:successPath,
            failurePath: failurePath,
            sourceType: sourceType,
            database: database,
            stagingTable: stagingTable,
            queries: queries,
            finalQuery: description,
            exportFormat: exportFormat,
            exportDest: exportDest,
            headerIdentifier: headerIdentifier,
            headerRowIdentifier:headerRowIdentifier,
            headerRowNumber:headerRowNumber,
            headerSelection:headerSelection,
            trimSuffix:trimSuffix,
            manualSchema:manualSchema,
            model:model,
            apiKey:apiKey,
            depth:depth,
            fileType:fileType,
            existingConfig:existingConfig
        } 
       }  else if (fileType=="xml") {
            console.log("fileType::1",fileType,contentTag)
            requestBodyState = {
                source:source,
                successPath:successPath,
                failurePath: failurePath,
                sourceType: sourceType,
                database: database,
                stagingTable: stagingTable,
                queries: queries,
                finalQuery: description,
                exportFormat: exportFormat,
                exportDest: exportDest,
                headerIdentifier: headerIdentifier,
                headerRowIdentifier:headerRowIdentifier,
                headerRowNumber:headerRowNumber,
                headerSelection:headerSelection,
                trimSuffix:trimSuffix,
                manualSchema:manualSchema,
                model:model,
                apiKey:apiKey,
                depth:depth,
                contentTag:contentTag,
                fileType:fileType,
                existingConfig:existingConfig
            }
    } else {
        console.log("mqtt_ai_req::1")
        requestBodyState = {
            host:host,
            port:port,
            source:source,
            successPath:successPath,
            failurePath: failurePath,
            sourceType: sourceType,
            database: database,
            stagingTable: stagingTable,
            queries: queries,
            finalQuery: description,
            exportFormat: exportFormat,
            exportDest: exportDest,
            headerIdentifier: headerIdentifier,
            headerRowIdentifier:headerRowIdentifier,
            headerRowNumber:headerRowNumber,
            headerSelection:headerSelection,
            trimSuffix:trimSuffix,
            manualSchema:manualSchema,
            model:model,
            depth:depth,
            apiKey:apiKey,
            fileType:fileType,
            existingConfig:existingConfig
        }
    };
      console.log("mqtt_ai_req::2",requestBodyState)
        //schema_str = get_schema(conn, req.table)
        //config = generate_config(schema_str, req.requirements, req.table)
        //const response = await fetch("http://localhost:8001/generate-config", {
        const response = await fetch(`${process.env.REACT_APP_AGENT_AI_SERVICE}/generate-config`, { 
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                ...await getAuthHeader(org_name),
            },
            body: JSON.stringify(requestBodyState)
        });

       return response
        // Do any additional processing or redirect as needed
    } catch (error) {
        console.error('Error fetching config:', error);
    }
};

export const generateSqlWithAgentAi = async (queryDescription,model,apiKey,org_name) => {
    try {

    const requestBodyState = {
        queryDescription: queryDescription,
        model:model,
        apiKey: apiKey
    };
    const response = await fetch(`${process.env.REACT_APP_AGENT_AI_SERVICE}/generate-sql`, { 
        method: 'POST',
        headers: {
            'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
            ...await getAuthHeader(org_name),
        },
        body: JSON.stringify(requestBodyState)
    });

    const data = await response.text();
    // Handle the response data from listStateFiles
 // You should see the list of connections in the console

    return data;
    // Do any additional processing or redirect as needed
} catch (error) {
    console.error('Error fetching config:', error);
}
};

export const storeUserSession = async (orgName,orgId,userName,userId,userRole,paymentStatus,jwtRefreshToken,jwtExpiry) => {

    try {
    const requestBodyState =  {
        orgName: orgName,
        orgId: orgId,
        userName: userName,
        userId: userId,
        userRole: userRole,
        paymentStatus: paymentStatus,
        jwtRefreshToken:jwtRefreshToken,
        jwtExpiry:jwtExpiry

    };
    const response = await fetch(`${process.env.REACT_APP_USER_MANAGEMENT_SERVICE}/storeUserSession`, { 
        method: 'POST',
        headers: {
            'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
            ...await getAuthHeader(orgName),
        },
        body: JSON.stringify(requestBodyState)
    });

    const data = await response.json();

    return data;
} catch (error) {
    console.error('Error fetching config:', error);
}
};

export const getUserSession = async (token) => {

    try {
    const requestBodyState =  {
        token: token,
    };
    const response = await fetch(`${process.env.REACT_APP_USER_MANAGEMENT_SERVICE}/getUserSession`, { 
        method: 'POST',
        headers: {
            'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
            ...await getAuthHeader(""),
        },
        body: JSON.stringify(requestBodyState)
    });

    const data = await response.json();

    return data;
} catch (error) {
    console.error('Error fetching config:', error);
}
};

export const deleteUserSession = async (token,org_name) => {

    try {
    const requestBodyState =  {
        token: token,
    };
    const response = await fetch(`${process.env.REACT_APP_USER_MANAGEMENT_SERVICE}/deleteUserSession`, { 
        method: 'POST',
        headers: {
            'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
            ...await getAuthHeader(org_name),
        },
        body: JSON.stringify(requestBodyState)
    });

    const data = await response.json();

    return data;
} catch (error) {
    console.error('Error fetching config:', error);
}
};


// 🔹 Generic API call helper
export const callApi = async (endpoint, body) => {

    const resp = await fetch(`${process.env.REACT_APP_USER_MANAGEMENT_SERVICE}${endpoint}`, {
      method: "POST",
      headers: {
        'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
        ...await getAuthHeader(),
    },
      body: JSON.stringify(body),
    });
    console.log("callApi::2");
    if (!resp.ok) {
      const msg = await resp.text();
      throw new Error(msg || "API request failed");
    }
    console.log("callApi::3", resp.status);
    return resp.json();
  };

export const callApiNoHeader = async (endpoint, body) => {

    const resp = await fetch(`${process.env.REACT_APP_USER_MANAGEMENT_SERVICE}${endpoint}`, {
      method: "POST",
      headers: {
        'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`
    },
      body: JSON.stringify(body),
    });
    /*
    if (!resp.ok) {
      const msg = await resp.text();
      throw new Error(msg || "API request failed");
    }
    */
    return resp.json();
  };





